import { render, staticRenderFns } from "./nutritionMainpageCalendar.vue?vue&type=template&id=3456f0dc&scoped=true"
import script from "./nutritionMainpageCalendar.vue?vue&type=script&lang=js"
export * from "./nutritionMainpageCalendar.vue?vue&type=script&lang=js"
import style0 from "./nutritionMainpageCalendar.vue?vue&type=style&index=0&id=3456f0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456f0dc",
  null
  
)

export default component.exports